var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addForm" },
    [
      _c(
        "el-form",
        {
          ref: "addForm",
          attrs: {
            model: _vm.addForm,
            "label-width": "300px",
            rules: _vm.formRole,
          },
        },
        [
          _vm._l(_vm.addForm.formList, function (item, index) {
            return _c(
              "el-row",
              { key: index, staticClass: "addFormItem" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "作品项名称",
                      prop: "formList." + index + ".name",
                      rules: _vm.formRole.name,
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "input", placeholder: "请选择作品项名称" },
                      model: {
                        value: item.name,
                        callback: function ($$v) {
                          _vm.$set(item, "name", $$v)
                        },
                        expression: "item.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "作品文件类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请选择文件类型" },
                        model: {
                          value: item.fileType,
                          callback: function ($$v) {
                            _vm.$set(item, "fileType", $$v)
                          },
                          expression: "item.fileType",
                        },
                      },
                      _vm._l(_vm.typeList, function (i, j) {
                        return _c("el-option", {
                          key: j,
                          attrs: { label: i.keyData, value: i.valueData },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "作品文件大小",
                      prop: "formList." + index + ".size",
                      rules: _vm.formRole.size,
                    },
                  },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: {
                          type: "input",
                          placeholder: "请输入作品文件大小",
                        },
                        model: {
                          value: item.size,
                          callback: function ($$v) {
                            _vm.$set(item, "size", $$v)
                          },
                          expression: "item.size",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("M")])],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "作品文件上传要求" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        placeholder: "请输入作品文件上传要求",
                        maxlength: "300",
                        "show-word-limit": "",
                      },
                      model: {
                        value: item.requirements,
                        callback: function ($$v) {
                          _vm.$set(item, "requirements", $$v)
                        },
                        expression: "item.requirements",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticClass: "addWorksItem" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.addItem(index)
                          },
                        },
                      },
                      [_vm._v("新增作品项")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "danger", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(index)
                          },
                        },
                      },
                      [_vm._v("删除作品项")]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "submitBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("addForm")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.isBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }